import { jsx } from "react/jsx-runtime";
import React from "react";
import { Icon, Button, Tooltip } from "@blueprintjs/core";
import { reduce } from "lodash-es";
export const viewColumn = {
  width: 35,
  noEllipsis: true,
  immovable: true,
  type: "action",
  render: () => {
    return /* @__PURE__ */ jsx(Icon, { className: "dt-eyeIcon", icon: "eye-open" });
  }
};
export const openColumn = ({ onDoubleClick, history }) => ({
  ...viewColumn,
  render: (val, record, rowInfo) => {
    return /* @__PURE__ */ jsx(Tooltip, { content: "Open", children: /* @__PURE__ */ jsx(
      Button,
      {
        onClick: (e) => {
          e.stopPropagation();
          onDoubleClick && onDoubleClick(rowInfo.original, rowInfo.index, history);
        },
        minimal: true,
        small: true,
        className: "dt-eyeIcon",
        icon: "document-open"
      }
    ) });
  }
});
export const multiViewColumn = {
  ...viewColumn,
  columnHeader: ({ recordIdToIsVisibleMap, setRecordIdToIsVisibleMap }) => {
    const allVisible = reduce(
      recordIdToIsVisibleMap,
      (acc, val) => acc && val,
      true
    );
    return /* @__PURE__ */ jsx(Tooltip, { content: allVisible ? "Hide All" : "Show All", children: /* @__PURE__ */ jsx(
      Button,
      {
        className: `showHideAllButton-${allVisible ? "visible" : "hidden"}`,
        minimal: true,
        onClick: () => {
          setRecordIdToIsVisibleMap(
            reduce(
              recordIdToIsVisibleMap,
              (acc, val, key) => {
                acc[key] = !allVisible;
                return acc;
              },
              {}
            )
          );
        },
        icon: allVisible ? "eye-open" : "eye-off"
      }
    ) });
  },
  render: (val, record, row, { recordIdToIsVisibleMap, setRecordIdToIsVisibleMap }) => {
    if (!recordIdToIsVisibleMap) {
      return null;
    }
    const isVisible = recordIdToIsVisibleMap[record.id];
    return /* @__PURE__ */ jsx(Tooltip, { content: isVisible ? "Hide" : "Show", children: /* @__PURE__ */ jsx(
      Button,
      {
        onClick: (e) => {
          e.stopPropagation();
          e.preventDefault();
          setRecordIdToIsVisibleMap(
            Object.assign({}, recordIdToIsVisibleMap, {
              [record.id]: !isVisible
            })
          );
        },
        minimal: true,
        small: true,
        className: `showHideButton-${isVisible ? "visible" : "hidden"}-${record.id}`,
        icon: isVisible ? "eye-open" : "eye-off"
      }
    ) });
  }
};
